import { render, staticRenderFns } from "./VerificationsDetailPage.vue?vue&type=template&id=056e5956&"
import script from "./VerificationsDetailPage.vue?vue&type=script&lang=js&"
export * from "./VerificationsDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056e5956')) {
      api.createRecord('056e5956', component.options)
    } else {
      api.reload('056e5956', component.options)
    }
    module.hot.accept("./VerificationsDetailPage.vue?vue&type=template&id=056e5956&", function () {
      api.rerender('056e5956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/VerificationsDetailPage.vue"
export default component.exports